import type { PartPreviewType } from "@/api/types";

/**
 * KAN-1401 — which viewer shows ONE part.
 *
 * An operation may analyze 2D and 3D uploads alike (two analyzers in its
 * pipeline), so the process-level ``preview_type`` cannot tell a DXF part
 * from an STL one. The API answers per part; the process value is only the
 * fallback for a response that predates the field.
 */
export function partPreviewType(
  itemPreviewType: PartPreviewType | null | undefined,
  processPreviewType: PartPreviewType | null | undefined,
): PartPreviewType {
  return itemPreviewType ?? processPreviewType ?? "none";
}
